<div class="metadata-div" style="margin-bottom: 20px;" [ngClass]="(visibility === 'MT_K' || visibility === 'MT_M') ? 'check-box-active-margin' : ''">
  <span class="input-field-label" [matTooltip]="label ? label : ''" matTooltipPosition="above">
    <span *ngIf="visibility === 'MT_K'">*</span>{{label}}
  </span>
  <div class="only-read-metadata-data-div-check" [ngClass]="getBorderClass()">
    <mat-checkbox labelPosition="after"
                  color="primary"
                  [(ngModel)]="value"
                  (change)="onChangeValue(value);onChangeHumanValue(value ? 'Igen' : 'Nem')" [disabled]="visibility==='MT_O'">
      <span [ngClass]="{'disabled-text': visibility==='MT_O'}">
        {{ value ? ('YES' | translate) : ('NO' | translate) }}
      </span>
    </mat-checkbox>
  </div>
  <mat-error *ngIf="visibility==='MT_K'&&!this.value" class="warning-text">{{'MANDATORY_FIELD' | translate}}</mat-error>
</div>
<!--<div class="metadata-div">-->
<!--  <div class="only-read-metadata-data-div">-->
<!--    <mat-checkbox labelPosition="after" [(ngModel)]="value" (change)="onChangeValue(value)">-->
<!--    <b>{{label}}</b>-->
<!--    </mat-checkbox>-->
<!--  </div>-->
<!--</div>-->
